import useEditNotification, {
  EditNotificationProps,
} from 'modules/notifications/hooks/use-edit-notification';
import {
  NotificationTypeEnum,
  translatedNotificationProps,
} from 'modules/notifications/types';
import notificationsKeys from 'modules/notifications/util/notifications-keys';
import weekDaySelect from 'modules/notifications/util/week-day-select';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditNotification: React.FC = () => {
  const {id} = useParams();
  const {
    getInput,
    getSwitch,
    getTextArea,
    getSelect,
    getDatePicker,
    getTimePicker,
  } = useFormInputs();

  return (
    <Edition<EditNotificationProps>
      titleBar={{title: 'Editar notificação'}}
      inputs={[
        getInput({
          name: 'title',
        }),
        getTextArea({name: 'body'}),
        getSwitch({
          name: 'active',
          hidden: (data) => data.type !== NotificationTypeEnum.periodical,
        }),
        getSelect({
          name: 'day',
          data: weekDaySelect,
          hidden: (data) => data.type !== NotificationTypeEnum.periodical,
        }),
        getDatePicker({
          name: 'date',
          hidden: (data) => data.type !== NotificationTypeEnum.oneTime,
        }),
        getTimePicker({
          name: 'time',
          hidden: (data) => data.type !== NotificationTypeEnum.oneTime,
        }),
      ]}
      detailsUrl={`/notifications/${id}`}
      onSubmit={() => useEditNotification(id!)}
      translationKey={translatedNotificationProps}
      queryKey={notificationsKeys.details(id!)}
    />
  );
};

export default EditNotification;
